import { createFileRoute } from '@tanstack/react-router';

export interface SearchParams {
  campaignName?: string;
  campaignType?: 'calls' | 'sms' | 'call-and-sms';
  locationId?: string;
}

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/analytics/marketing-attribution/campaign_/$number')({
  staticData: { team: 'analytics' },
  validateSearch: (search: SearchParams) => {
    return search;
  },
});
